var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 62,
    viewBox: "0 0 9 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 62,
    fill: "#D7D7D7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Version 2.0 - Under Review"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-20033 -4593C-20033 -4594.1 -20032.1 -4595 -20031 -4595H6224C6225.1 -4595 6226 -4594.1 6226 -4593V7879C6226 7880.1 6225.11 7881 6224 7881H-20031C-20032.1 7881 -20033 7880.1 -20033 7879V-4593Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20031 -4594H6224V-4596H-20031V-4594ZM6225 -4593V7879H6227V-4593H6225ZM6224 7880H-20031V7882H6224V7880ZM-20032 7879V-4593H-20034V7879H-20032ZM-20031 7880C-20031.6 7880 -20032 7879.55 -20032 7879H-20034C-20034 7880.66 -20032.7 7882 -20031 7882V7880ZM6225 7879C6225 7879.55 6224.55 7880 6224 7880V7882C6225.66 7882 6227 7880.66 6227 7879H6225ZM6224 -4594C6224.55 -4594 6225 -4593.55 6225 -4593H6227C6227 -4594.66 6225.66 -4596 6224 -4596V-4594ZM-20031 -4596C-20032.7 -4596 -20034 -4594.66 -20034 -4593H-20032C-20032 -4593.55 -20031.6 -4594 -20031 -4594V-4596Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "NX_1366x768 - 50",
    clipPath: "url(#clip0_1_140)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 768,
    transform: "translate(-421 -465)",
    fill: "#F0F4F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 80",
    clipPath: "url(#clip1_1_140)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2131",
    x: -290.5,
    y: -280.5,
    width: 1185,
    height: 909,
    fill: "white",
    stroke: "#F2F2F4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2133",
    x: -290.5,
    y: -221.5,
    width: 299,
    height: 850,
    fill: "white",
    stroke: "#F2F2F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 4419"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2136",
    d: "M0 4L9 0L9 62L4.5 60L0 58L0 4Z",
    fill: "#DAE4ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 21",
    d: "M2 31L7.25 26.6699L7.25 35.3301L2 31Z",
    fill: "#7D92A5"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 768,
    fill: "white",
    transform: "translate(-421 -465)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1186,
    height: 584,
    fill: "white",
    transform: "translate(-291 -281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.ef5f38b4489e0859a8ec332f7b8b443c.svg";
export { ForwardRef as ReactComponent };